import { render, staticRenderFns } from "./NewErrorpage.vue?vue&type=template&id=4d09d598&scoped=true"
import script from "./NewErrorpage.vue?vue&type=script&lang=js"
export * from "./NewErrorpage.vue?vue&type=script&lang=js"
import style0 from "./NewErrorpage.vue?vue&type=style&index=0&id=4d09d598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d09d598",
  null
  
)

export default component.exports